import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=00d70c28&"
import script from "./ProductAddons.vue?vue&type=script&lang=js&"
export * from "./ProductAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports